import { onMounted, onUnmounted, type Ref } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';

type ModalRef = Ref<{ confirm: () => Promise<boolean> } | null>;

export function useUnsavedChangesGuard(hasUnsavedChanges: () => boolean, modalRef: ModalRef) {
  const handleBeforeUnload = (e: BeforeUnloadEvent) => {
    if (hasUnsavedChanges()) {
      e.preventDefault();
    }
  };

  onBeforeRouteLeave(async () => {
    if (!hasUnsavedChanges()) return;
    const leave = await (modalRef.value?.confirm() ?? Promise.resolve(true));
    if (!leave) return false;
  });

  onMounted(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
  });

  onUnmounted(() => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  });
}
